import type { TourId } from "@/lib/tours/types";

const STORAGE_PREFIX = "eh-tour-seen-";

export function hasSeenTour(tourId: TourId): boolean {
  try {
    return localStorage.getItem(`${STORAGE_PREFIX}${tourId}`) === "1";
  } catch {
    return true;
  }
}

export function markTourSeen(tourId: TourId): void {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${tourId}`, "1");
  } catch {
    /* Speicher optional */
  }
}

export function resetTourSeen(tourId: TourId): void {
  try {
    localStorage.removeItem(`${STORAGE_PREFIX}${tourId}`);
  } catch {
    /* Speicher optional */
  }
}

export function resetAllTours(): void {
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key?.startsWith(STORAGE_PREFIX)) keysToRemove.push(key);
    }
    for (const key of keysToRemove) localStorage.removeItem(key);
  } catch {
    /* Speicher optional */
  }
}
